import React, { useState } from "react";
import FormField from "./FormField";
import AlertRedIcon from "../../img/alert-red.svg";

const FormInputField = ({ label, name, type, onChange, required = true }) => {
  const [invalid, setInvalid] = useState(false);
  const onInvalid = () => setInvalid(true);

  return (
    <FormField label={label} name={name}>
      <input
        className={`input ${invalid ? "is-danger" : ""}`}
        type={type}
        name={name}
        onChange={onChange}
        id={`input-${name}`}
        required={required}
        onInvalid={onInvalid}
      />
      {invalid ? (
        <span className="icon is-right">
          <img src={AlertRedIcon} alt="" />
        </span>
      ) : null}
    </FormField>
  );
};

export default FormInputField;
